import axios from 'axios';

export default {
  FETCH_PODCASTS ({commit, dispatch}, payload){
    return new Promise((resolve, reject) => {
      commit('TOGGLE_LOADING', true);
      // axios.post('login/authenticate', payload)
      axios.get('common/getAllPodcasts')
        .then((response) => {
          const { data: { data : { payload } } } = response;
          console.log('podcast data', payload)
          localStorage.setItem('podcasts', JSON.stringify(payload));
          commit('SET_PODCAST', payload);
          commit('TOGGLE_LOADING', false);
          resolve(payload);
        })
        .catch((error) => {
          console.log('action fetch error : ', error);
          reject(error);
          commit('TOGGLE_LOADING', false);
        });
    })
  },
  GET_ADVISORY_BOARD ({commit}, groupName){
    return new Promise((resolve, reject) => {
      commit('TOGGLE_LOADING', true);
      // axios.post('login/authenticate', payload)
      axios.get(`/common/getAdvisoryBoard/${groupName}`)
        .then((response) => {
          const { data: { data : { payload } } } = response;
          console.log('[inside action.js] Advisoryboard data', payload)
          localStorage.setItem('advisoryBoard', JSON.stringify(payload));
          commit('SET_ADVISORY_BOARD', payload);
          commit('TOGGLE_LOADING', false);
          resolve(payload);
        })
        .catch((error) => {
          console.log('GET_ADVISORY_BOARD -> action fetch error : ', error);
          reject(error);
          commit('TOGGLE_LOADING', false);
        });
    })
  },
  GETSELECTEDPODCAST ({ commit }, podcastId) {
        commit('TOGGLE_LOADING', true);
        return axios.get(`common/getAllPodcasts`).then((response) => {
            commit('TOGGLE_LOADING', false);
            const { data: { data : { payload }} } = response;

            console.log('payload', payload)
            let selectedPodcast = payload.filter(x => {
              return x.podcastId.toString() === podcastId.toString()
            });

            console.log('inside podcasts/actions.js >>>> podcastId = ', podcastId)
            commit('SET_SELECTED_PODCAST', selectedPodcast[0])
        }, (err) => {
            commit('TOGGLE_LOADING', false);
            console.log('err ', err)
        })
    },
    GET_SELECTED_ADVISORYBOARD ({ commit }, advisoryBoardId) {
      commit('TOGGLE_LOADING', true);
      return axios.get(`common/getAdvisoryBoardById/${advisoryBoardId}`).then((response) => {
        commit('TOGGLE_LOADING', false);
        const { data: { data : { payload }} } = response;

        console.log('[inside actions.js --> GET_SELECTED_ADVISORYBOARD] ---> payload', payload)
        // let selectedPodcast = payload.filter(x => {
        //   return x.podcastId.toString() === podcastId.toString()
        // });
        console.log('inside podcasts/actions.js >>>> selected advisory board = ', payload)
        commit('SET_SELECTED_ADVISORY_BOARD', payload)
      }, (err) => {
        commit('TOGGLE_LOADING', false);
        console.log('err ', err)
      })
    },
    ADD_PODCAST({commit, dispatch}, payload){
        return new Promise((resolve, reject) => {
            commit('TOGGLE_LOADING', true);
            console.log("ADD_PODCAST payload : ", payload);
            axios.post('common/insertPodcast', payload)
                .then((response) => {
                    console.log('ADD_PODCAST action fetch response : ', response);
                    const { data: { data } } = response;
                    commit('TOGGLE_LOADING', false);
                    resolve(data);
                })
                .catch((error) => {
                    console.log('ADD_PODCAST action fetch error : ', error);
                    reject(error);
                    commit('TOGGLE_LOADING', false);
                });
        })
    },
    ADD_ADVISORY_BOARD({commit, dispatch}, payload){
      return new Promise((resolve, reject) => {
        commit('TOGGLE_LOADING', true);
        console.log("ADD_ADVISORY_BOARD payload : ", payload);
        axios.post('common/insertAdvisoryBoard', payload)
          .then((response) => {
            console.log('ADD_ADVISORY_BOARD action fetch response : ', response);
            const { data: { data } } = response;
            commit('TOGGLE_LOADING', false);
            resolve(data);
          })
          .catch((error) => {
            console.log('ADD_ADVISORY_BOARD action fetch error : ', error);
            reject(error);
            commit('TOGGLE_LOADING', false);
          });
      })
    },
    UPDATE_PODCAST({commit, dispatch}, payload){
        return new Promise((resolve, reject) => {
            // payload.csvCorporationId = payload.csvCorporationId.toString()
            commit('TOGGLE_LOADING', true);
            axios.put('/common/updatePodcast', payload)
                .then((response) => {
                    const { data: { data } } = response;
                    commit('TOGGLE_LOADING', false);
                    resolve(data);
                })
                .catch((error) => {
                    console.log('UPDATE_PODCAST action fetch error : ', error);
                    reject(error);
                    commit('TOGGLE_LOADING', false);
                });
        })
    },
    UPDATE_ADVISORY_BOARD({commit, dispatch}, payload){
      return new Promise((resolve, reject) => {
        // payload.csvCorporationId = payload.csvCorporationId.toString()
        commit('TOGGLE_LOADING', true);
        axios.put('/common/updateAdvisoryBoard', payload)
          .then((response) => {
            const { data: { data } } = response;
            commit('TOGGLE_LOADING', false);
            resolve(data);
          })
          .catch((error) => {
            console.log('UPDATE_ADVISORY_BOARD action fetch error : ', error);
            reject(error);
            commit('TOGGLE_LOADING', false);
          });
      })
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/podcasts/actions.js